/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// Maps step categories to friendly tag labels
const TAG_MAP = {
  AML: null,        // handled specially via name-based PEPs/Sanctions/Media logic
  KYC: "KYC",
  IDV: "Biometrics",
  MATCHLIST: "Blocklist",
  FRAUD: "Fraud",
  VISA: "Visa",
  ENTITY_LOOKUP: "Entity Lookup",
  DUPLICATE: "Duplicate Check",
  SUPPORTING_DOCUMENTS_CHECK: "Supporting Docs",
  ORGANIZATIONDATAFETCH: "Org Data Fetch",
  ORGANIZATIONPERSIST: "Org Persist",
  REPORT: "Report",
  ACTIVITY: "Activity Monitoring",
};

// Hidden from tags — internal/operational categories
const HIDDEN_CATS = new Set(["DECISION", "TOGGLEMONITORING"]);

// Derive region from workflow key prefix
const REGION_PREFIXES = [
  { prefix: "GLB-", label: "Global", flag: "🌐" },
  { prefix: "IND-", label: "India", flag: "🇮🇳" },
  { prefix: "USA-", label: "United States", flag: "🇺🇸" },
  { prefix: "CAN-", label: "Canada", flag: "🇨🇦" },
  { prefix: "NZL-", label: "New Zealand", flag: "🇳🇿" },
  { prefix: "GBR-", label: "United Kingdom", flag: "🇬🇧" },
];

function getRegion(key: string) {
  for (const r of REGION_PREFIXES) {
    if (key.startsWith(r.prefix)) return r;
  }
  return { prefix: "", label: "Australia", flag: "🇦🇺" };
}

function getAmlTags(name: string) {
  const lower = (name || "").toLowerCase();
  if (lower.includes("advanced")) return ["PEPs", "Sanctions", "Media"];
  return ["PEPs", "Sanctions"];
}

function WorkflowRow({ wf, checkBadge }: { wf: any; checkBadge: any }) {
  const amlSteps = wf.steps.AML || [];
  const kycSteps = wf.steps.KYC || [];
  const hasAml = amlSteps.length > 0;
  const amlTags = hasAml ? getAmlTags(wf.name) : [];
  // Build KYC label from sources
  const kycLabel = (() => {
    if (kycSteps.length === 0) return "KYC";
    const parts = [];
    const hasManual = kycSteps.some(s => s.name.toLowerCase().includes("manual"));
    const hasDvs = kycSteps.some(s => s.name.includes("DVS") && s.name.toLowerCase().includes("documents only"));
    const hasEquifax = kycSteps.some(s => s.name.toLowerCase().includes("equifax"));
    const hasExperian = kycSteps.some(s => s.name.toLowerCase().includes("experian"));
    const hasSuperchoice = kycSteps.some(s => s.name.toLowerCase().includes("superchoice"));
    const hasSocure = kycSteps.some(s => s.name.toLowerCase().includes("socure"));
    const hasDatazoo = kycSteps.some(s => s.name.toLowerCase().includes("datazoo"));
    const hasCentrix = kycSteps.some(s => s.name.toLowerCase().includes("centrix"));
    if (hasManual) parts.push("Manual");
    if (hasDvs) parts.push("Gov ID");
    if (hasEquifax) parts.push("Equifax");
    if (hasExperian) parts.push("Experian");
    if (hasSuperchoice) parts.push("Superchoice");
    if (hasSocure) parts.push("Socure");
    if (hasDatazoo) parts.push("Datazoo");
    if (hasCentrix) parts.push("Centrix");
    return parts.length > 0 ? `KYC - ${parts.join(", ")}` : "KYC";
  })();

  // Check if all vendors are testbed
  const allVendors = kycSteps.map(s => s.vendor).filter(Boolean);
  const allTestbed = allVendors.length > 0 && allVendors.every(v => v.startsWith("testbed"));

  // Build tag list from step categories
  const tags = [];
  if (hasAml) {
    amlTags.forEach(t => tags.push({ label: t, bg: "#fef3c7", color: "#92400e" }));
  }
  for (const [cat, items] of Object.entries(wf.steps)) {
    if (HIDDEN_CATS.has(cat) || cat === "AML") continue;
    let label = TAG_MAP[cat] || cat;
    if (cat === "KYC") label = kycLabel;
    const s = (checkBadge && checkBadge[cat]) || { bg: "#f3f4f6", color: "#374151" };
    if (items.length > 0) tags.push({ label, bg: s.bg, color: s.color });
  }
  if (allTestbed) {
    tags.push({ label: "Testbed", bg: "#f3f4f6", color: "#6b7280" });
  }

  return (
    <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, marginBottom: 10, overflow: "hidden", pageBreakInside: "avoid" }}>
      <div style={{ padding: "10px 14px" }}>
        {/* Name + key */}
        <div style={{ display: "flex", alignItems: "baseline", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
          <span style={{ fontWeight: 700, fontSize: 13, color: "#1e293b" }}>{wf.name}</span>
          <code className="api-docs-only" style={{ background: "#e8f0ff", padding: "1px 6px", borderRadius: 3, fontSize: 10, color: "#4285fb" }}>{wf.key}</code>
        </div>

        {/* Tags */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: kycSteps.length > 0 ? 6 : 0 }}>
          {tags.map((t, i) => (
            <span key={i} style={{ background: t.bg, color: t.color, padding: "2px 8px", borderRadius: 10, fontSize: 9, fontWeight: 600, whiteSpace: "nowrap" }}>
              {t.label}
            </span>
          ))}
        </div>

        {/* KYC source details */}
        {kycSteps.length > 0 && (
          <div style={{ fontSize: 10, color: "#666", lineHeight: 1.6, paddingLeft: 2 }}>
            <span style={{ color: "#888", fontWeight: 600 }}>KYC sources:</span>{" "}
            {kycSteps.map((s, i) => {
              return (
                <span key={i}>
                  {i > 0 && <span style={{ color: "#ccc" }}> · </span>}
                  <span style={{ color: "#444" }}>{s.name}</span>
                  {s.vendor && <span style={{ color: "#aaa" }}> — {s.vendor}</span>}
                </span>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default function WorkflowsDisplay({ recipes, checkBadge }: { recipes: any[]; checkBadge: any }) {
  if (!recipes || recipes.length === 0) {
    return (
      <div>
        <h2 style={{ color: "#4285fb", borderBottom: "2px solid #4285fb", paddingBottom: 6, marginBottom: 16 }}>
          Workflows & Service Profiles
        </h2>
        <p style={{ fontSize: 13, color: "#999", fontStyle: "italic" }}>No workflows configured yet.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ color: "#4285fb", borderBottom: "2px solid #4285fb", paddingBottom: 6, marginBottom: 16 }}>
        Workflows & Service Profiles
      </h2>

      <p style={{ fontSize: 12, color: "#444", lineHeight: 1.6, marginBottom: 12 }}>
        Workflows are predefined sequences of checks configured for your account. Each workflow defines which check types run and in what order — including KYC data source verification, government ID checks, AML screening, blocklist matching, biometrics, and decision logic.
      </p>

      <div className="api-docs-only" style={{ background: "#e8f0ff", borderLeft: "4px solid #4285fb", padding: "10px 14px", margin: "0 0 20px", borderRadius: "0 4px 4px 0", fontSize: 12, lineHeight: 1.7 }}>
        <strong>How to discover your workflows:</strong> Call <code style={{ background: "#dbeafe", padding: "2px 5px", borderRadius: 3, fontSize: 11, color: "#4285fb" }}>GET /v2/workflows</code> with your credentials to see which workflows are available to your account.
      </div>

      <div style={{ background: "#fef3c7", borderLeft: "4px solid #f59e0b", padding: "10px 14px", margin: "0 0 20px", borderRadius: "0 4px 4px 0", fontSize: 12, lineHeight: 1.7 }}>
        <strong>AML vendor naming — testbed vs mock/sandbox:</strong>
        <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
          <li style={{ marginBottom: 4 }}>
            <strong>testbed-aml</strong> — FrankieOne's internal testbed connector. Returns pre-canned, static AML/PEP/sanctions responses for specific test names. Fast and predictable for UAT, but limited in fidelity (fields, formats, and richness are only what's hard-coded).
          </li>
          <li>
            <strong>ComplyAdvantage mock / sandbox</strong> — ComplyAdvantage's own test environments. These return real-style responses with the same fields, formats, and richer mapping (e.g. source country codes) as production. Recommended when you need to validate exact provider behaviour or granular field mapping.
          </li>
        </ul>
      </div>

      <div style={{ background: "#e0e7ff", borderLeft: "4px solid #6366f1", padding: "10px 14px", margin: "0 0 20px", borderRadius: "0 4px 4px 0", fontSize: 12, lineHeight: 1.7 }}>
        <strong>AML screening scope — Advanced vs Basic/Standard:</strong>
        <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
          <li style={{ marginBottom: 4 }}>
            <strong>Advanced</strong> workflows include full AML screening: <strong>PEPs + Sanctions + Adverse Media</strong>.
          </li>
          <li>
            <strong>Basic / Standard</strong> workflows include <strong>PEPs + Sanctions</strong> only (no adverse media checks).
          </li>
        </ul>
      </div>

      <h3 style={{ color: "#333", marginTop: 24, marginBottom: 10 }}>Configured Workflows</h3>

      {(() => {
        // Group workflows by region
        const grouped = {};
        recipes.forEach(wf => {
          const region = getRegion(wf.key);
          const key = region.label;
          if (!grouped[key]) grouped[key] = { region, workflows: [] };
          grouped[key].workflows.push(wf);
        });
        // Sort: Australia first, then alphabetical
        const sorted = Object.values(grouped).sort((a, b) => {
          if (a.region.label === "Australia") return -1;
          if (b.region.label === "Australia") return 1;
          return a.region.label.localeCompare(b.region.label);
        });
        return sorted.map(({ region, workflows }) => (
          <div key={region.label} style={{ marginBottom: 20 }}>
            <h4 style={{ color: "#475569", fontSize: 13, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
              <span>{region.flag}</span> {region.label}
              <span style={{ fontSize: 10, fontWeight: 400, color: "#94a3b8" }}>({workflows.length})</span>
            </h4>
            {workflows.map(wf => (
              <WorkflowRow key={wf.key} wf={wf} checkBadge={checkBadge} />
            ))}
          </div>
        ));
      })()}
    </div>
  );
}
